<template>
  <div>
    <div class="row" v-if="loading">
      <div class="page-content-state page-content-state-loading col-12">
        <span class="page-content-state__icon  far fa-spinner-third fa-spin"></span>
        <div class="page-content-state__content">Generating plan link</div>
      </div>
    </div>
    <div class="row" v-else-if="error">
      <div class="page-content-state col-12">
        <span class="page-content-state__icon fal fa-sad-cry"></span>
        <div class="page-content-state__header">Sorry, there was a problem generating the plan link</div>
      </div>
    </div>
    <div class="row academic-modal" v-else>
      <div class="col-12">
        <b-container class="form-group mb-0 p-0">
          <h5>Academic Chair:</h5>
          <p>{{academicChair[0].name}} - {{academicChair[0].email}}</p>
          <b-row cols="2">
            <b-col>
              <h5>Course:</h5>
              <p>{{course.code}} - {{course.name}}</p>
            </b-col>
            <b-col v-if="selectedMajors.length > 0" class="col-6">
              <h5>Major/s:</h5>
              <p v-for="major in selectedMajors" :key="major.relationship.code">{{major.relationship.code}} - {{major.relationship.name}}</p>
            </b-col>
          </b-row>
          <b-row cols="1">
            <b-col>
              <h5 id="student-name-head">Student name:</h5>
              <input class="form-control mb-3" id="student-name" v-model="username" aria-labelledby="student-name-head" />
            </b-col>
          </b-row>
          <b-row cols="1">
            <b-col>
              <h5>Student notes:</h5>
              <div class="form-group pb-0 mb-0">
                <textarea class="form-control" id="student-notes" v-model="studentNotes" style="min-height: 72px;" aria-labelledby="student-notes-head"
                  ref="studentNoteTextarea"
                  v-on:keyup="textAreaSize"></textarea>
              </div>

            </b-col>
          </b-row>

        </b-container>
        <button class="mt-3 btn btn-primary w-25" @click="sendEmailLink()"><i class="fa fa-envelope"></i> Send</button>
      </div>
    </div>

  </div>
</template>

<style scoped lang="scss"></style>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  props: {
    plan: {
      type: String
    },
    academicChair: {
      type: Array
    },
    selectedMajors: {
      type: Array
    }
  },
  data() {
    return {
      loading: true,
      error: false,
      id: null,
      emailLink: null,
      username: ''
    }
  },
  computed: {
    ...mapGetters({
      getBasePath: 'global/getBaseUrl',
      course: 'courses/getSelectedCourse',
      getStudentNotes: 'plans/getStudentNotes'
    }),
    studentNotes: {
      get() {
        return this.getStudentNotes
      },
      set(value) {
        this.setStudentNotes(value)
      }
    },
    getBaseUrl() {
      let url = new URL(this.getBasePath + '/', window.location.origin)
      return url
    }
  },
  methods: {
    ...mapActions({
      storeCoursePlan: 'savedCourse/storeCoursePlan'
    }),
    ...mapMutations({
      setStudentNotes: 'plans/setStudentNotes'
    }),
    textAreaSize() {
      this.$refs.studentNoteTextarea.style.minHeight = '0'
      this.$refs.studentNoteTextarea.style.height = '1px'
      if (this.$refs.studentNoteTextarea.scrollHeight + 25 > 72) {
        this.$refs.studentNoteTextarea.style.minHeight = this.$refs.studentNoteTextarea.scrollHeight + 25 + 'px'
      } else {
        this.$refs.studentNoteTextarea.style.minHeight = '72px'
      }
    },
    sendEmailLink() {
      let { username, emailLink, studentNotes, course } = this
      let academicChair = this.academicChair[0]
      window.location = `mailto:${academicChair.email}?subject=Course Plan - ${course.code} - ${course.name}&body=Hi ${
        academicChair.name
      },%0D%0A%0D%0APlease find a student's course plan at the link below.%0D%0A${emailLink} %0D%0A%0D%0AStudent Notes:%0D%0A${encodeURIComponent(
        studentNotes
      )}%0D%0A%0D%0AThanks,%0D%0A${username}%0D%0A%0D%0ADisclaimer`
    },
    copyLink() {
      this.$refs.copyLinkUrl.focus()
      document.execCommand('copy')
    },
    mailtoLink() {
      this.emailLink = this.getBaseUrl + 'saved-plan?id=' + this.id
    }
  },
  async mounted() {
    try {
      this.loading = true
      this.id = await this.storeCoursePlan()
      this.loading = false
      this.mailtoLink()
    } catch (ex) {
      this.loading = false
      this.error = true
    }
  }
}
</script>
<style></style>
